export enum OldCardState {

    Deactivated = 'DEACTIVATED',
    NotReturned = 'NOT_RETURNED',
    Returned = 'RETURNED',
    
}


export const oldCardStates: { [ key: string ]: string } = { };

oldCardStates[ OldCardState.Deactivated ] = 'Deactivated';
oldCardStates[ OldCardState.NotReturned ] = 'Not Returned';
oldCardStates[ OldCardState.Returned ] = 'Returned';